<template>
  <v-layout row>
    <v-flex 
      xs12 
      md8 
      offset-md2>
      <v-card v-if="step['.key']">
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>
            <span class="headline">{{ step.name }}</span>            
          </v-toolbar-title>
          <stepForm 
            v-if="step['.key']" 
            :edititem="step"/>
        </v-toolbar>
        <v-card-text>
          <table>
            <tr>
              <th class="text-xs-left">Type:</th>
              <td>{{ step.type }}</td>
            </tr>
            <tr v-if="step.alertStudent">
              <th class="text-xs-left">Student message:</th>
              <td>
                <v-icon 
                  left 
                  :color="step.type === 'Student' ? 'success' : 'info'" >
                  {{ step.type === 'Student' ? 'edit' : 'info' }}
                </v-icon>      
                {{ step.alertStudent }}
              </td>
            </tr>
            <tr v-if="step.alertOrganisation">
              <th class="text-xs-left">Organisation message:</th>
              <td>
                <v-icon 
                  left 
                  :color="step.type === 'Organisation' ? 'success' : 'info'">
                  {{ step.type === 'Organisation' ? 'edit' : 'info' }}
                </v-icon>      
                {{ step.alertOrganisation }}
              </td>
            </tr>
            <tr v-if="step.alertStaff">
              <th class="text-xs-left">Staff/Academic message:</th>
              <td>  
                <v-icon 
                  left 
                  :color="step.type === 'Staff' ? 'success' : 'info'" >
                  {{ step.type === 'Staff' ? 'edit' : 'info' }}
                </v-icon>     
                {{ step.alertStaff }}
              </td>
            </tr>  
            <tr v-if="step.emailStudent || step.emailOrganisation || step.emailOther">
              <th class="text-xs-left">Email:</th>
              <td>{{ step.emailStudent ? 'Student' : '' }} {{ step.emailOrganisation ? 'Organisation' : '' }} {{ step.emailOther ? step.emailOther : '' }}</td>
            </tr>          
          </table>
        </v-card-text>
        <v-card-title primary-title>
          <h3 class="title">Use <v-icon>drag_handle</v-icon> (drag and drop icon) to re-order the list.</h3>
        </v-card-title>
        <v-list subheader>
          <draggable 
            :list="step.formData" 
            :options="{handle:'.v-icon'}"
            @end="onEnd">
            <v-list-tile 
              v-for="(item, index) in step.formData" 
              :key="index"
              avatar          
              @click="openBlock(item, index)">
              <v-list-tile-action>
                <v-icon>drag_handle</v-icon>
              </v-list-tile-action>
              <!-- textblock was renamed to htmlblock -->
              <v-list-tile-content 
                v-if="item.type == 'htmlblock'">
                <strong>HTML CONTENT:</strong> {{ item.html.slice(0, 100) + (item.html.length > 100 ? '...' : '') }}
              </v-list-tile-content>
              <v-list-tile-content 
                v-if="item.type == 'inputblock'">
                <strong>TEXT INPUT:</strong> {{ item.label }}        
              </v-list-tile-content>
              <v-list-tile-content 
                v-if="item.type == 'numberblock'">
                <strong>NUMBER INPUT:</strong> {{ item.label }}        
              </v-list-tile-content>
              <v-list-tile-content 
                v-if="item.type == 'selectblock'">
                <strong>SELECT DROPDOWN:</strong> {{ item.label }}
              </v-list-tile-content>
              <v-list-tile-content 
                v-if="item.type == 'standardblock'">
                <strong>STANDARD:</strong> {{ item.html.slice(0, 100) + (item.html.length > 100 ? '...' : '') }}
              </v-list-tile-content>  
              <v-list-tile-content 
                v-if="item.type == 'fileblock'">
                <strong>FILE UPLOAD:</strong> {{ item.label }}        
              </v-list-tile-content>
            </v-list-tile>
          </draggable>
        </v-list>
        <v-card-actions class="justify-center">
          <v-btn 
            flat 
            color="primary"
            @click="openBlock({
              html: '',
              value: true,
              show: false,
              type: 'htmlblock',
            }, null)"
          >
            <v-icon>code</v-icon> HTML            
          </v-btn>
          <v-btn 
            flat 
            color="primary"
            @click="openBlock({
              label: null,
              value: null,
              maxSize: 100,
              minSize: 0,
              required: true,
              show: true,
              type: 'inputblock',
              csv: false,
              csvKey: null,
              hide: []
            })"
          >
            <v-icon>text_format</v-icon> Text          
          </v-btn>
          <v-btn 
            flat
            color="primary"
            @click="openBlock({
              label: null,
              value: null,
              required: true,
              show: true,
              integer: false,
              type: 'numberblock',
              csv: false,
              csvKey: null
            })"
          >
            <v-icon>looks_4</v-icon> Number          
          </v-btn>
          <v-btn 
            flat
            color="primary"
            @click="openBlock({
              label: null,
              value: null,
              required: true,
              show: true,
              options: [],
              type: 'selectblock',
              csv: false,
              csvKey: null
            })"
          >
            <v-icon>keyboard_arrow_down</v-icon> Select           
          </v-btn>
          <v-btn 
            flat 
            color="primary"
            @click="openBlock({
              html: '',
              value: null,
              required: true,
              show: true,
              options: [],
              type: 'standardblock',
              csv: false,
              csvKey: null
            })"
          >
            <v-icon>assignment_turned_in</v-icon> Standard   
          </v-btn>
          <v-btn 
            flat
            color="primary"
            @click="openBlock({
              label: null,
              value: null,
              required: true,
              show: true,
              type: 'fileblock',
              progress: 0,
              csv: false,
              csvKey: null
            })"
          >
            <v-icon>save</v-icon> File upload             
          </v-btn>
        </v-card-actions>
        <htmlblock 
          :dialog="dialogs.htmlblock"   
          :htmlitem="item"
          @statusDialog="dialogs.htmlblock = $event"
          @saveItem="saveItem"/>
        <inputblock 
          :dialog="dialogs.inputblock"   
          :inputitem="item"
          @statusDialog="dialogs.inputblock = $event"
          @saveItem="saveItem"/>
        <numberblock 
          :dialog="dialogs.numberblock"   
          :numberitem="item"
          @statusDialog="dialogs.numberblock = $event"
          @saveItem="saveItem"/>
        <selectblock 
          :dialog="dialogs.selectblock"
          :selectitem="item"
          @statusDialog="dialogs.selectblock = $event"
          @saveItem="saveItem"/>
        <standardblock 
          :dialog="dialogs.standardblock"
          :standarditem="item"
          @statusDialog="dialogs.standardblock = $event"
          @saveItem="saveItem"/>
        <fileblock 
          :dialog="dialogs.fileblock"
          :fileitem="item"
          @statusDialog="dialogs.fileblock = $event"
          @saveItem="saveItem"/>
        <v-card-text id="create"/> 
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import draggable from "vuedraggable";
import adminComponents from "@/components/admin";

export default {
  name: "Step",
  components: {
    draggable,
    ...adminComponents
  },
  data: () => ({
    hidden: false,
    fab: false,
    valid: true,
    dialogs: {
      htmlblock: false,
      numberblock: false,
      inputblock: false,
      selectblock: false,
      standardblock: false,
      fileblock: false
    },
    step: null,
    // blocks: null,
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length < 100) || "Name must be less than 100 characters"
    ],
    showOptions: "show",
    item: null,
    selectedIndex: null
  }),
  firestore() {
    return {
      step: this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .collection("units")
        .doc(this.$route.params.unit)
        .collection("steps")
        .doc(this.$route.params.step)
    };
  },
  methods: {
    saveItem(saveItem) {
      let formData = this.step.formData ? this.step.formData : [];
      let toast = "";
      // Add or Update
      if (this.selectedIndex != null) {
        if (saveItem != null) {
          formData[this.selectedIndex] = saveItem;
          toast = saveItem.type.toUpperCase() + " UPDATED";
        } else {
          formData.splice(this.selectedIndex, 1);
          toast = "DELETED ELEMENT";
        }
      } else {
        formData.push(saveItem);
        toast = saveItem.type.toUpperCase() + " ADDED";
      }
      this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .collection("units")
        .doc(this.$route.params.unit)
        .collection("steps")
        .doc(this.$route.params.step)
        .update({ formData })
        .then(() => {
          this.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "success",
            timeout: 6000,
            text: toast
          });
          this.$store.dispatch("setLoading", false);
        })
        .catch(error => {
          console.error("Error writing document: ", error);
          this.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "error",
            timeout: 6000,
            text: "FAILED TO MAKE CHANGES"
          });
          this.$store.dispatch("setLoading", false);
        });
    },
    openBlock(block, index) {
      this.item = block;
      this.selectedIndex = index;
      this.dialogs[block.type] = true;
    },
    onEnd(evt) {
      this.$store.dispatch("setLoading", true);
      let formData = this.step.formData;
      this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .collection("units")
        .doc(this.$route.params.unit)
        .collection("steps")
        .doc(this.$route.params.step)
        .update({ formData })
        .then(() => {
          this.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "success",
            timeout: 6000,
            text: "LIST REORDERED"
          });
          this.$store.dispatch("setLoading", false);
        })
        .catch(error => {
          console.error("Error writing document: ", error);
          this.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "error",
            timeout: 6000,
            text: "FAILED TO MAKE CHANGES"
          });
          this.$store.dispatch("setLoading", false);
        });
    }
  }
};
</script>

<style>
.whitespace {
  white-space: pre-wrap;
}

#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
</style>
